module.exports = __webpack_public_path__ + "media/application/images/svgs/git-pull-request-7d5ed0afd4616d81bc62406dbbc00175.svg";